module.exports = __webpack_public_path__ + "img/Greenleaf.01bd54d2.png";